import { render, staticRenderFns } from "./HeaderImage.vue?vue&type=template&id=106d567a&functional=true&"
import script from "./HeaderImage.vue?vue&type=script&lang=js&"
export * from "./HeaderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports